
import React from "react";
import ModalForm from "components/FormComponents/ModalForm/ModalForm";
import useSave from "Hooks/useSave";
import {crudFunctions} from "api";
import {CLIENTE} from "api/TYPES";
import { Button, CircularProgress, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import {post, get, put, remove, upload, init, updateCliente} from "api";
import { useQuery, useQueryClient } from "react-query";
import styled from "styled-components";
import Joi from "helpers/joi";
import regimenes from "assets/catalogos/regimenes";
import { useTranslation } from "react-i18next";

const DatosIniciales = ({onClose}) => {
	const { t, i18n } = useTranslation();
	
	const csdElements = React.useMemo(() => [
		{
			type:"select",
			label: t('profile.fiscalRegime'),
			name:"legales.regimen_fiscal",
			options:regimenes
		}
	], [t]);
	
	const actions = crudFunctions(CLIENTE);
	const {data:dataCliente} = useQuery(CLIENTE.name, actions.getAll);


	const {data, onChange, onFile, removeFile, save, status, isValid, setValid} = useSave({
		data:dataCliente?.cliente,
		crudActions: actions
		// updateValidation: dataCliente?.tipo==="fisica" ? validation : validationEmpresa
	});

	const handleLanguageChange = (event) => {
		const newLanguage = event.target.value;
		i18n.changeLanguage(newLanguage);
		localStorage.setItem('language', newLanguage);
	};


	

	const elementsPersonaFisica = React.useMemo(()=>[
		{
			type: "text",
			label: t('profile.rfc'),
			name: "legales.rfc",
		},
		{
			type: "file",
			label: t('profile.ine'),
			name: "legales.ine",
			acceptFiles:true

		},
		{
			type: "gAutocomplete",
			label: t('profile.fiscalAddress'),
			name: "legales.direccion_fiscal",
		},
		...csdElements,
		{
			type: "gAutocomplete",
			name:"direccion",
			label: t('profile.deliveryAddress'),
		},
		{
			type: "text",
			label: t('profile.notificationEmail'),
			name: "correo_notif"
		},


		
	],[t]);
	const elementsPersonaMoral = React.useMemo(()=>[
		{
			type: "text",
			label: t('profile.companyName'),
			name: "legales.razon_social"
		},
		{
			type: "text",
			label: t('profile.rfc'),
			name: "legales.rfc"
		},
		{
			type: "gAutocomplete",
			label: t('profile.fiscalAddress'),
			name: "legales.direccion_fiscal",
		},
		...csdElements,
		{
			type: "file",
			label: t('profile.taxStatusCertificate'),
			name: "legales.csf",
			acceptFiles:true
		},
		{
			type: "file",
			label: t('profile.legalRepIne'),
			name: "legales.ine",
			acceptFiles:true
		},
		{
			type: "gAutocomplete",
			name:"direccion",
			label: t('profile.deliveryAddress'),
			
		},
		{
			type: "text",
			label: t('profile.notificationEmail'),
			name: "correo_notif"
		},


		
	],[t]);
	return (
		<div style={{maxWidth:600, margin:"auto", }}>
			<Title>{t('profile.title')}</Title>
			{/* <H4>Por favor completa la siguiente informaci ón de tu empresa</H4> */}
			
			{/* Language Settings Section */}
			<LanguageSection>
				<LanguageSectionTitle>{t('profile.languageSettings')}</LanguageSectionTitle>
				<p style={{color: '#666', marginBottom: 15, fontSize: '0.9em'}}>{t('profile.languageDescription')}</p>
				<FormControl variant="outlined" style={{minWidth: 200}}>
					<InputLabel id="language-select-label">{t('configuration.language')}</InputLabel>
					<Select
						labelId="language-select-label"
						id="language-select"
						value={i18n.language?.split('-')[0] || 'es'}
						onChange={handleLanguageChange}
						label={t('configuration.language')}
					>
						<MenuItem value="es">
							<span style={{display: 'flex', alignItems: 'center', gap: 8}}>
								🇲🇽 {t('configuration.spanish')}
							</span>
						</MenuItem>
						<MenuItem value="en">
							<span style={{display: 'flex', alignItems: 'center', gap: 8}}>
								🇺🇸 {t('configuration.english')}
							</span>
						</MenuItem>
					</Select>
				</FormControl>
			</LanguageSection>

			<ModalForm hideBox elements={dataCliente?.tipo==="fisica" ? elementsPersonaFisica : elementsPersonaMoral} onChange={onChange} data={data} onFile={onFile} removeFile={removeFile}>
				{status.status==="LOADING" && <CircularProgress />}
				{status.status==="SUCCESS" && <Alert severity="success">{t('profile.savedSuccess')}</Alert>}
				{status.status==="ERROR" && <Alert severity="error">{status?.errorMsg}</Alert>}
				{status.status!=="LOADING" && <Button variant="contained" color="primary" onClick={save}>{t('common.save')}</Button>}

			</ModalForm>
			<div style={{marginTop:30, marginBottom:30}}>
				{/* <a>Aviso de privacidad</a> */}
				<a style={{textDecoration:"underline", color:"blue"}} href="https://vink.com.mx/files/terminos_cliente.pdf" target="_blank">{t('profile.termsAndConditions')}</a>
			</div>
		</div>
	);
};
export default DatosIniciales;

const Title = styled.h2`
	margin:20px;
`;
const H4 = styled.h4`
	margin:20px;
`;

const LanguageSection = styled.div`
	background: #f8f9fa;
	border-radius: 12px;
	padding: 20px;
	margin: 20px;
	margin-bottom: 30px;
`;

const LanguageSectionTitle = styled.h3`
	margin: 0 0 10px 0;
	color: #333;
	font-size: 1.1em;
`;

// Título: 
// RFC: 
// Adjuntar INE:
// Domicilio donde quieren recibir evidencias de entrega: Calle-Colonia-No interior, Cp, Ciudad
// Uso de las facturas: Gastos en general que salga por default editable
// Correo principal para pagos y facturas:

// PM Luego: Popup ya en la plataforma (si escogió en el inicio de sesión que es cuenta empresarial pedir estos datos)

// Título: Datos de facturación, pagos y evidencias
// Razón social:
// Adjuntar constancia de situación fiscal:
// Adjuntar INE del representante legal:
// Uso de las facturas: Gastos en general que salga por default editable
// Correo principal para pagos y facturas:
// Domicilio donde quieren recibir evidencias de entrega: Calle-Colonia-No interior, Cp, Ciudad
// Texto: ¿Te gustaría pagar tus fletes con crédito? Contáctanos a x correo

// Notify Isaac C. about m
